import React from "react";
import OurClient from "../../OurClient/OurClient";
import Faq from "../../Faq/Faq";

const data = {
  faqHeader: "Logo Design Services – Frequently Asked Questions",
  caption:
    "Before engaging our logo design services, clear your doubts. For more assistance, feel free to ask our experts.",
  faqContent: [
    {
      ques: "Why is Brand Identity Important for Businesses?",
      ans: "A strong brand identity is crucial for businesses as it fosters recognition, builds trust, and sets a unique tone in the market. It helps differentiate your business from competitors and creates a cohesive and memorable brand experience for your audience.",
    },
    {
      ques: "How Do You Develop a Consistent Brand Identity?",
      ans: "Developing a consistent brand identity involves creating and adhering to a set of brand guidelines. This includes maintaining uniformity in design elements, messaging, and overall brand presentation across all platforms and communication channels.",
    },
    {
      ques: "How Do You Develop a Consistent Brand Identity?",
      ans: "Developing a consistent brand identity involves creating and adhering to a set of brand guidelines. This includes maintaining uniformity in design elements, messaging, and overall brand presentation across all platforms and communication channels.",
    },
    {
      ques: "Can You Help Refresh an Existing Brand Identity?",
      ans: " Absolutely! Whether you're looking for a complete rebrand or a subtle refresh, our brand identity services are tailored to meet your needs. We work collaboratively to understand your goals and breathe new life into your existing brand, aligning it with current market trends and audience expectations.",
    },
  ],
};

export default function BrandIdentity() {
  return (
    <>
      <section class="logo_design_sec1 bg_color1">
        <div class="container">
          <div class="row g-4 align-items-center">
            <div class="col-lg-8 col-sm-9">
              <div
                class="heading"
                data-aos="fade-right"
                data-aos-duration="2000"
              >
                <h1>Brand Identity</h1>
                <p>
                  At Adret Software , we understand the power of a compelling
                  brand identity. In today's competitive landscape, your brand
                  is more than just a logo; it's the essence of your company's
                  personality. We specialize in the art and science of creating
                  unique brand identities that captivate audiences and leave a
                  lasting impression.
                </p>
                <div class="btn_sec ">
                  <a href="" class="btn1 btn_gap">
                    Quick Enquiry
                  </a>
                  <a href="" class="btn3">
                    See our Work
                  </a>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-sm-3">
              <img
                src="assets/image/logo-design.png"
                class="img-fluid"
                data-aos="zoom-in"
                data-aos-duration="2000"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
      <section class="logo_design_business">
        <div class="container">
          <div class="row">
            <div class="col-lg-8">
              <div class="heading" data-aos="fade-up" data-aos-duration="2000">
                <h2>Our Mission</h2>
                <p>
                  At Adret Software, our mission is to be the architects of
                  distinction, guiding businesses to forge identities that
                  transcend the ordinary. We are committed to breathing life
                  into brands, understanding that they are not merely symbols
                  but living entities that connect with people. Our mission is
                  rooted in the belief that every brand deserves to be unique,
                  authentic, and unforgettable.
                </p>
                <p>
                  We strive to empower businesses, large and small, with the
                  tools to articulate their essence and values through
                  compelling visual and verbal expressions. By combining
                  creativity with strategic insight, we aim to shape brand
                  identities that resonate in the hearts and minds of audiences,
                  fostering trust and loyalty.
                </p>
                <div class="btn_sec">
                  <a href="" class="btn1 btn_gap">
                    Request a Quote
                  </a>
                  <a href="" class="btn3">
                    Our Packages
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="logo_design_best">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center">
              <div class="heading" data-aos="fade-up" data-aos-duration="2000">
                <h2>Brand Identity Services - Crafted for Excellence</h2>
                <p>
                  Elevate your brand with our top-notch brand identity services.
                  As a leading provider in the industry, we specialize in
                  creating cohesive and impactful brand identities for
                  businesses of all sizes, from startups to established
                  enterprises. Our dedicated team of brand strategists and
                  designers works collaboratively to capture the essence of your
                  brand and communicate it effectively to your target audience.
                </p>
              </div>
            </div>
          </div>
          <div class="row justify-content-center">
            <div class="col-lg-10">
              <iframe
                width="100%"
                src="https://www.youtube.com/embed/JI1jipPbkQM"
                title="Adret intro video"
                frameborder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowfullscreen
                data-aos="zoom-out"
                data-aos-duration="2000"
              ></iframe>
            </div>
          </div>
        </div>
      </section>
      <section class="logo_design_project p-0">
        <div class="row g-0 ">
          <div class="col-lg-5">
            <div
              class="content_img"
              data-aos="fade-right"
              data-aos-duration="2000"
            >
              <img
                src="assets/image/logo-design-img1.jpg"
                class="img-fluid"
                alt=""
              />
            </div>
          </div>
          <div class="col-lg-7">
            <div class="heading" data-aos="fade-left" data-aos-duration="2000">
              <h2>What can we do for you?</h2>
              <p>We would be happy to discuss the project with you in person</p>
              <h4>
                Call To Us : <a href="tel:+91 9432205976">+91 9432205976</a>
              </h4>
              <div class="btn_sec">
                <a href="" class="btn2">
                  Drop in a message
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="logo_design_sec">
        <div class="container">
          <div class="heading" data-aos="fade-up" data-aos-duration="2000">
            <h2>
              Why Choose Adret Software for <br />
              Professional Brand Identity Services
            </h2>
            <p>
              A compelling brand identity is the cornerstone of successful
              marketing. At Adret Software, a leading brand identity service
              provider, we create impactful brand identities that resonate with
              your audience. Our experienced team of brand strategists and
              designers blends creativity with strategic insight to craft a
              brand identity that sets you apart.
            </p>
          </div>
          <div class="row g-4">
            <div class="col-lg-8">
              <div class="row">
                <div class="col-lg-6">
                  <div
                    class="content_why"
                    data-aos="fade-up"
                    data-aos-duration="2000"
                  >
                    <div class="left_icon">
                      <img
                        src="assets/image/logo-design-icon1.png"
                        alt=""
                        class="img-fluid"
                      />
                    </div>
                    <div class="content">
                      <h5>Strategic Brand Analysis</h5>
                      <p>
                        Our brand identity process begins with a thorough
                        analysis of your brand's essence and market positioning.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div
                    class="content_why"
                    data-aos="fade-up"
                    data-aos-duration="2000"
                  >
                    <div class="left_icon">
                      <img
                        src="assets/image/logo-design-icon2.png"
                        alt=""
                        class="img-fluid"
                      />
                    </div>
                    <div class="content">
                      <h5>Creative Design Solutions</h5>
                      <p>
                        At Adret Software, we go beyond aesthetics. Our design
                        solutions are crafted with creativity at the core
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div
                    class="content_why"
                    data-aos="fade-up"
                    data-aos-duration="2000"
                  >
                    <div class="left_icon">
                      <img
                        src="assets/image/logo-design-icon3.png"
                        alt=""
                        class="img-fluid"
                      />
                    </div>
                    <div class="content">
                      <h5>Strategic Content Development</h5>
                      <p>
                        Content is king, and at Adret Software, we understand
                        its strategic importance.
                      </p>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div
                    class="content_why"
                    data-aos="fade-up"
                    data-aos-duration="2000"
                  >
                    <div class="left_icon">
                      <img
                        src="assets/image/logo-design-icon4.png"
                        alt=""
                        class="img-fluid"
                      />
                    </div>
                    <div class="content">
                      <h5>Data-Driven Marketing Insights</h5>
                      <p>
                        Harness the power of data to fuel your marketing
                        strategies.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="btn_sec" data-aos="fade-up" data-aos-duration="3000">
                <a href="" class="btn1">
                  Explore Brand Identity Services
                </a>
              </div>
            </div>
            <div class="col-lg-4">
              <img
                src="assets/image/logo-design-img2.png"
                class="img-fluid  rounded"
                alt=""
                data-aos="zoom-out"
                data-aos-duration="2000"
              />
            </div>
          </div>
        </div>
      </section>

      <section class="portfolio_logo bg_color1">
        <div class="container">
          <div class="row">
            <div class="col-lg-12 text-center row_gap">
              <div class="heading" data-aos="fade-up" data-aos-duration="2000">
                <h2>Explore Our Brand Identity Showcase</h2>
              </div>
            </div>
          </div>
          <div class="row g-3">
            <div class="col-lg-4 col-sm-4 col-6">
              <div
                class="logo_con_port"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/logo-design-protfolio-img1.jpg"
                  alt=""
                  class="img-fluid"
                />
              </div>
            </div>
            <div class="col-lg-4 col-sm-4 col-6">
              <div
                class="logo_con_port"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/logo-design-protfolio-img1.jpg"
                  alt=""
                  class="img-fluid"
                />
              </div>
            </div>
            <div class="col-lg-4 col-sm-4 col-6">
              <div
                class="logo_con_port"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/logo-design-protfolio-img1.jpg"
                  alt=""
                  class="img-fluid"
                />
              </div>
            </div>
            <div class="col-lg-4 col-sm-4 col-6">
              <div
                class="logo_con_port"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/logo-design-protfolio-img1.jpg"
                  alt=""
                  class="img-fluid"
                />
              </div>
            </div>
            <div class="col-lg-4 col-sm-4 col-6">
              <div
                class="logo_con_port"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/logo-design-protfolio-img1.jpg"
                  alt=""
                  class="img-fluid"
                />
              </div>
            </div>
            <div class="col-lg-4 col-sm-4 col-6">
              <div
                class="logo_con_port"
                data-aos="zoom-in"
                data-aos-duration="2000"
              >
                <img
                  src="assets/image/logo-design-protfolio-img1.jpg"
                  alt=""
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 row-below text-center">
              <div class="btn_sec" data-aos="zoom-in" data-aos-duration="2000">
                <a href="" class="btn1">
                  See Full Portfolio
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
      <OurClient />
      <Faq data={data} />
    </>
  );
}
